/*
 * 水利行业
 */
import React from 'react';
import SkeletonNew from 'components/solution/skeletonNew';
import { headBg, headBgM, challenge, frameSrc, frameSrcM, frame, advantage, scene, caseList } from 'constants/solution/waterCon-solution';

const watercon = () => {
  return (
    <SkeletonNew
      headFixed={true}
      challenge={challenge}
      caseList={caseList}
      advantage={advantage}
      scene={scene}
      frame={frame}
      headBg={headBg}
      headBgM={headBgM}
      title="水利行业解决方案"
      simpleDesc="赋能数字孪生流域 创新推进智慧水利"
      desc={`小鱼易连打造集水利会议系统、监控系统、单兵系统、指挥车等于一体的音视频集控系\n统，满足大规模、多场景、广覆盖、全业务嵌入的内外部高清视频沟通需求，赋能数字\n孪生水利工程建设，助力水利治理、防汛抗旱等智慧水利日常管理。`}
      pageTitle="水利行业"
      tdkWord="waterConservancy"
      frameSrc={frameSrc}
      frameSrcM={frameSrcM}
    />
  );
};

export default watercon;
